import React from 'react';
import { motion } from 'framer-motion';
import { Countdown } from './Countdown';
import { OfferSelector } from './OfferSelector';
export function Pricing() {
  return <section id="pricing" className="py-10 md:py-20 relative" data-id="element-191">
      {/* Background glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-brand-gold/5 rounded-full blur-3xl -z-10 pointer-events-none" data-id="element-192"></div>

      <div className="max-w-3xl mx-auto px-4 md:px-6" data-id="element-193">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-6 md:mb-8" data-id="element-194">
          <h2 className="text-3xl md:text-5xl font-serif font-bold text-white mb-2 md:mb-3" data-id="element-195">
            Elegí tu Edición
          </h2>
          <p className="text-base md:text-xl text-gray-400" data-id="element-196">
            Empezá a cocinar bien este fin de semana
          </p>
        </motion.div>

        <Countdown data-id="element-197" />

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="mt-6 md:mt-8" data-id="element-198">
          <OfferSelector data-id="element-199" />
        </motion.div>
      </div>
    </section>;
}